module.exports = __webpack_public_path__ + "img/slide_prev_white.cdae8185.png";